import { KsService } from '@siclop/kstone-vue'

export class LeaveTypeService extends KsService {
  protected static mainUrl = '/leave-types'
}
